import { render, staticRenderFns } from "./tasks-list-view.vue?vue&type=template&id=feda63dc&scoped=true"
import script from "./tasks-list-view.vue?vue&type=script&lang=js"
export * from "./tasks-list-view.vue?vue&type=script&lang=js"
import style0 from "./tasks-list-view.vue?vue&type=style&index=0&id=feda63dc&prod&lang=scss&scoped=true"
import style1 from "./tasks-list-view.vue?vue&type=style&index=1&id=feda63dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feda63dc",
  null
  
)

export default component.exports